import $ from 'jquery';
export default function scrollTopAnimated() {
  $("html, body").animate({
    scrollTop: 0
  }, 1000);
}
;